import React, { useContext, useState } from 'react';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const SkillDetailsModal = ({ skill, onClose, onSkillUpdated }) => {
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(skill.completed);

  const handleToggle = async () => {
    if (!skill.playerId || !skill.id) {
      alert("Missing player or skill ID");
      return;
    }

    setLoading(true);
    const method = completed ? 'DELETE' : 'POST';

    await fetch(`https://vballbackend.onrender.com/api/player/${skill.playerId}/skill/${skill.id}`, {
      method,
      headers: { Authorization: `Bearer ${token}` }
    });

    setCompleted(!completed);
    setLoading(false);

    if (onSkillUpdated) {
      onSkillUpdated();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000
      }}
    >
      <div className="card" style={{
        width: '500px',
        maxHeight: '80vh',
        overflowY: 'auto',
        padding: '2rem',
        position: 'relative'
      }}>
        <h2 className="mb-2">{skill.name}</h2>
        <p><strong>Difficulty:</strong> {skill.difficulty}</p>
        <p><strong>Description:</strong> {skill.description}</p>
        <p><strong>Coach Tip:</strong> {skill.coachTip}</p>
        <p className="mt-2" style={{ fontWeight: 'bold' }}>
          {completed
            ? `Completed on ${skill.dateCompleted}`
            : "Incomplete"}
        </p>

        <div className="flex-row mt-4" style={{ justifyContent: 'flex-end', gap: '1rem' }}>
          <button
            className="btn-primary"
            onClick={handleToggle}
            disabled={loading}
          >
            {completed ? "Mark as Incomplete" : "Mark as Complete"}
          </button>
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default SkillDetailsModal;
